import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.analysis');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-analysis',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.analysis/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAnalysisComponent implements OnInit {
    public loading = true;
    public data: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const { code, data } = await wiz.call("full");
        if (code === 401) {
            location.href = "/";
            return;
        }
        if (code === 200) this.data = data;
        this.loading = false;
        await this.service.render();
    }

    public get globalCorr(): { key: string; value: number }[] {
        const p = this.data?.correlation_global?.pearson || {};
        return Object.entries(p)
            .map(([k, v]) => ({ key: k, value: Number(v) }))
            .sort((a, b) => Math.abs(b.value) - Math.abs(a.value));
    }

    public get perSampleRows(): any[] {
        const ps = this.data?.per_sample_corr || {};
        return Object.entries(ps).map(([name, v]: any) => ({
            name,
            short: this.shortOf(name),
            ...v,
        })).sort((a, b) => b.I3_cv - a.I3_cv);
    }

    public get aggTable(): any[] {
        return this.data?.aggregate_table || [];
    }

    public get sampleGroups(): any[] {
        const groups: { [k: string]: any[] } = {};
        for (const r of this.aggTable) {
            const s = (r.sample.match(/26AN\d+/) || [r.sample])[0];
            (groups[s] = groups[s] || []).push(r);
        }
        return Object.entries(groups).map(([name, rows]: any) => ({ name, rows }));
    }

    public shortOf(name: string): string {
        const idx = name.search(/26AN\d+/);
        if (idx < 0) return name;
        const rest = name.slice(idx);
        const end = rest.search(/[^\w]/);
        return end < 0 ? rest : rest.slice(0, end);
    }

    public fmt(v: any, d = 2): string {
        return v == null ? '-' : Number(v).toFixed(d);
    }

    public barWidth(value: number, max = 1): string {
        const ratio = Math.min(Math.abs(value) / max, 1);
        return (ratio * 100) + '%';
    }

    public corrBgClass(v: number): string {
        const a = Math.abs(v);
        if (a >= 0.7) return v > 0 ? 'bg-red-500' : 'bg-blue-500';
        if (a >= 0.4) return v > 0 ? 'bg-red-300' : 'bg-blue-300';
        if (a >= 0.2) return v > 0 ? 'bg-red-200' : 'bg-blue-200';
        return 'bg-gray-200';
    }

    public corrCellClass(v: number): string {
        const a = Math.abs(v);
        if (a >= 0.9) return v > 0 ? 'bg-red-500 text-white' : 'bg-blue-500 text-white';
        if (a >= 0.7) return v > 0 ? 'bg-red-400 text-white' : 'bg-blue-400 text-white';
        if (a >= 0.4) return v > 0 ? 'bg-red-200 text-red-900' : 'bg-blue-200 text-blue-900';
        if (a >= 0.2) return v > 0 ? 'bg-red-50 text-red-700' : 'bg-blue-50 text-blue-700';
        return 'bg-gray-50 text-gray-500';
    }

    public cvBadge(cv: number): string {
        if (cv > 12) return 'bg-red-100 text-red-700 ring-red-200';
        if (cv > 7) return 'bg-amber-100 text-amber-700 ring-amber-200';
        return 'bg-emerald-100 text-emerald-700 ring-emerald-200';
    }

    public corrKeys(): string[] {
        return ["ASC_mean", "ASC_std", "ASC_cv", "ASC_cells", "ASC_out_high", "vehicle_mean", "vehicle_std", "vehicle_cv", "vehicle_cells", "vehicle_out_high"];
    }

    public corrKeyLabel(k: string): string {
        return k.replace('_', ' ');
    }

    public topDriver(row: any): { key: string; value: number } | null {
        const cc = row.pearson_vs_I3 || {};
        let best: { key: string; value: number } | null = null;
        for (const k of Object.keys(cc)) {
            const v = Number(cc[k]);
            if (isNaN(v)) continue;
            if (!best || Math.abs(v) > Math.abs(best.value)) best = { key: k, value: v };
        }
        return best;
    }

    // --- Algorithm-level insights ---
    public get insights(): any {
        return this.data?.algorithm_insights || null;
    }

    public get varianceTable(): any[] {
        return this.insights?.variance_table || [];
    }

    public get rootCauses(): any[] {
        return this.insights?.root_causes || [];
    }

    public get recommendations(): any[] {
        return this.insights?.recommendations || [];
    }

    public severityClass(s: string): string {
        if (s === 'critical') return 'bg-rose-100 text-rose-800 ring-rose-300';
        if (s === 'high') return 'bg-orange-100 text-orange-800 ring-orange-300';
        if (s === 'medium') return 'bg-amber-100 text-amber-800 ring-amber-300';
        return 'bg-gray-100 text-gray-700 ring-gray-300';
    }

    public severityLabel(s: string): string {
        return ({ critical: '치명', high: '높음', medium: '중간', low: '낮음' } as any)[s] || s;
    }

    public expanded: { [k: string]: boolean } = {};
    public async toggle(id: string) {
        this.expanded[id] = !this.expanded[id];
        await this.service.render();
    }
}

export default PageAnalysisComponent;